(function(){
  // Update cart count on add-to-cart (AJAX, no redirect) so the header badge stays live.
  function updateCount(){
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var el = document.querySelector('[data-cart-count]');
        if(el){ el.textContent = c.item_count; }
      })
      .catch(function(){});
  }

  var form = document.querySelector('[data-product-form]');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if(btn){ btn.setAttribute('disabled','disabled'); btn.textContent = 'Added'; }
      fetch('/cart/add.js', {
        method:'POST',
        credentials:'same-origin',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({
          items:[{ id: Number(form.querySelector('[name="id"]').value), quantity: Number(form.querySelector('[name="quantity"]').value)||1 }]
        })
      })
      .then(function(){ updateCount(); })
      .catch(function(){})
      .finally(function(){
        setTimeout(function(){
          if(btn){ btn.removeAttribute('disabled'); btn.textContent = 'Add to cart'; }
        }, 1200);
      });
    });
  }
})();
